module.exports = __webpack_public_path__ + "static/media/jsImg.7f130501.png";